import { Group, Stack } from "@mantine/core";
import {
  useLeadsContainerStore,
  useLeadsFrontStore,
  useLeadsSheetStore,
  useLeadsStore,
} from "../../../../stores/LeadsStore";
import { useEffect } from "react";
import Container from "./Container";
import ContainersFooter from "./ContainersFooter";

const Containers = () => {
  const systemStatuses = useLeadsStore((s) => s.systemStatuses);
  const customStatuses = useLeadsStore((s) => s.customStatuses);
  const containers = useLeadsContainerStore((s) => s.containers);
  const setContainers = useLeadsContainerStore((s) => s.setContainers);
  const reloadAll = useLeadsContainerStore((s) => s.reloadAll);
  const setReloadAll = useLeadsContainerStore((s) => s.setReloadAll);

  useEffect(() => {
    const sizes = useLeadsFrontStore.getState().sizes;
    const setSizes = useLeadsFrontStore.getState().setSizes;

    let newContainers = [...systemStatuses, ...customStatuses].map((x, i) => {
      return {
        ...x,
        items: [],
        total: null,
        loading: true,
        nextPageUrl: null,
        sort: null,
        loadingNext: false,
        size: sizes?.[x.id] || 275,
      };
    });
    let newSizes = { ...sizes };
    newContainers.forEach((item) => {
      newSizes[item.id] = sizes?.[item.id] || 275;
    });
    setSizes(newSizes);
    setContainers(newContainers.sort((a, b) => a?.sorting - b?.sorting));
  }, []);

  useEffect(() => {
    if (reloadAll) {
      setReloadAll(false);

      setContainers(
        containers.map((x) => ({ ...x, loaded: false, loading: true }))
      );
    }
  }, [reloadAll]);

  // Auto open sheet
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const contactId = searchParams.get("contact");
    const containerId = searchParams.get("container");
    const index = searchParams.get("index");

    if (contactId) {
      const current = {
        properties: [],
        programmations: [],
        calls: [],
        status: null,
        custom_status: null,
        score: null,
        amount: null,
        probability: null,
        closing_date: null,
        workflow_waiting_steps: [],
        tags: [],
        in_active_programmation: false,
      };
      const setOpened = useLeadsSheetStore.getState().setOpened;
      const setIndex = useLeadsSheetStore.getState().setIndex;
      const setCurrent = useLeadsSheetStore.getState().setCurrent;
      const setCurrentContainer =
        useLeadsSheetStore.getState().setCurrentContainer;
      const setActiveTab = useLeadsSheetStore.getState().setActiveTab;
      const setLoading = useLeadsSheetStore.getState().setLoading;
      setOpened(true);
      current.id = parseInt(contactId);
      setCurrent(current);
      setActiveTab("summary");
      setLoading(true);

      if (containerId) {
        let container = containers?.find((x) =>
          parseInt(containerId)
            ? x.id === parseInt(containerId)
            : x.id === containerId
        );
        setCurrentContainer(container);
      }
      else {
        setCurrentContainer({ items: [] });
      }
      if (index) {
        setIndex(parseInt(index));
      }
    }
  }, []);

  return (
    <Stack flex={1} bg={"#fff"} p={"md"} style={{ borderRadius: 12 }}>
      <Group
        h={"100%"}
        style={{ overflow: "auto" }}
        flex={"1 1 auto"}
        w={0}
        miw={"100%"}
        id="main-prm"
        align="stretch"
      >
        <Group wrap="nowrap">
          {containers
            .filter((x) => x.visible)
            .map((container) => (
              <Container
                key={container?.id || container?.status}
                container={container}
              />
            ))}
        </Group>
      </Group>

      <ContainersFooter />
    </Stack>
  );
};

export default Containers;
